import { isBrand, isInternal } from "../../../../utils";

export const canViewPreviousVersions = (role?: string | null, file?: { version?: number }) =>
    (isInternal(role) || isBrand(role)) && (file?.version ?? 0) > 1;
